const updates = [
  { date: '07-31', title: '《长相思》第二季全集上线，大结局热度破纪录', tag: '热播' },
  { date: '07-30', title: '暑期档动画电影《哪吒之魔童闹海》高清版已更新', tag: '电影' },
  { date: '07-29', title: '《奔跑吧·生态篇》最新一期全网同步更新', tag: '综艺' },
  { date: '07-28', title: '国产悬疑剧《乌云之上》口碑爆棚，豆瓣评分9.1', tag: '悬疑' },
  { date: '07-27', title: 'Netflix热播韩剧《甜蜜家园3》中字高清上线', tag: '韩剧' },
  { date: '07-26', title: '《流浪地球3》发布首支预告，定档2025春节', tag: '预告' },
  { date: '07-25', title: '《王牌对王牌8》沈腾贾玲回归，笑点密集升级', tag: '综艺' },
  { date: '07-24', title: '国产科幻动画《灵笼》第二季官宣定档', tag: '动漫' },
  { date: '07-23', title: '《封神第二部》曝光全新角色海报，阵容豪华', tag: '电影' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-timer-flash-line"></i>实时快讯
          </span>
          <h2 className="font-heading text-[28px] md:text-4xl text-foreground-950 mb-3">最新更新动态</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            全网影视动态实时追踪，第一时间掌握最新上线内容
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-300">
            {updates.map((item, i) => (
              <div key={i} className={`relative pb-8 ${i === updates.length - 1 ? 'pb-0' : ''}`}>
                <div className="absolute -left-[29px] md:-left-[33px] w-[14px] h-[14px] rounded-full bg-accent-500 border-2 border-background-100" />
                <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4">
                  <span className="text-xs font-medium text-foreground-500 bg-background-50 px-2 py-0.5 rounded whitespace-nowrap w-fit">{item.date}</span>
                  <span className="text-sm md:text-base text-foreground-800 leading-relaxed">{item.title}</span>
                  <span className="shrink-0 px-2 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-700 whitespace-nowrap w-fit">{item.tag}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}